import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DmarcEffectivenessTable from '../../components/domain-progress/dmarc-effectiveness-table';

import { exportToCSVFailure, exportToCSVSuccess } from '../../actions/export-report-action-creators';
import { effectTableIsExportingGridToCSV, flattenedDmarcEffectivenessSelector } from '../../selectors/dmarc-effectiveness-selectors';
import { selectedIntervalSelector } from '../../selectors/reports-selectors';


export class DmarcEffectivenessTableContainer extends Component{
    render(){
        const {
            flattenedDmarcEffectivenessData, interval, isExportingGridToCSV, exportToCSVSuccess, exportToCSVFailure
        } = this.props;
        return (
            <DmarcEffectivenessTable
                interval={interval}
                data={flattenedDmarcEffectivenessData}
                isExportingGridToCSV={isExportingGridToCSV}
                exportToCSVSuccess={exportToCSVSuccess}
                exportToCSVFailure={exportToCSVFailure} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        flattenedDmarcEffectivenessData: flattenedDmarcEffectivenessSelector( state ),
        interval: selectedIntervalSelector( state ),
        isExportingGridToCSV: effectTableIsExportingGridToCSV( state )
    };
};

DmarcEffectivenessTableContainer.propTypes = {
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    flattenedDmarcEffectivenessData: PropTypes.array.isRequired,
    interval: PropTypes.string.isRequired,
    isExportingGridToCSV: PropTypes.bool,
};

export default connect(
    mapStateToProps,
    { exportToCSVFailure, exportToCSVSuccess }
)( DmarcEffectivenessTableContainer );
